import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingScreenService } from '../shared-services/loading-screen.service';


@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {

    activeRequests = 0;

    skippUrls = [
        '/zipData',
        '/vendor/filtered',
        '/salesperson/filtered',
        '/userpreferences',
        '/validateVendorEmail',
        '/salespersonbyvendor',
        '/transaction/validate',
        'datarobotmodel/modelBacklogStatus'
    ];

    constructor(private loadingScreenService: LoadingScreenService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let displayLoadingScreen = true;

        for (const skippUrl of this.skippUrls) {
            if (new RegExp(skippUrl).test(request.url)) {
                displayLoadingScreen = false;
                break;
            }
        }

        if (request.params['interceptorMetadata']) {
            if (request.params['interceptorMetadata'].options) {
                if (request.params['interceptorMetadata'].options.finicity) {
                    this.loadingScreenService.startFinicityLoading();
                    displayLoadingScreen = false;
                }
            }
        }

        if (displayLoadingScreen) {
            if (this.activeRequests === 0) {
                this.loadingScreenService.startLoading();
            }
            this.activeRequests++;

            return next.handle(request).pipe(
                finalize(() => {
                    this.activeRequests--;
                    if (this.activeRequests === 0) {
                        this.loadingScreenService.stopLoading();
                    }
                })
            );
        } else {
            return next.handle(request);
        }
    }

}
